var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8101 0.145212L16.2348 7.64956L14.8007 14.4849L13.6912 7.69624L12.4404 0.0259307C12.9533 0.0103723 13.4714 0 13.9948 0C15.3189 0 16.5959 0.0518616 17.8101 0.145212ZM9.24262 0.22819C3.86243 0.762363 0.0157009 2.17818 0 3.83775C0 3.84293 0 3.84293 0 3.84812V3.91554C0.0104673 4.10224 0.073271 4.28894 0.183178 4.47046L13.9791 28L10.4987 7.57696L9.24262 0.22819ZM23.0228 0.907575L21.4475 7.11021L17.7368 21.6936L27.8168 4.47564C27.8744 4.37711 27.9215 4.27338 27.9529 4.16966C27.9791 4.08668 27.9948 4.0037 28 3.92073V3.85331V3.84293C27.9791 2.66049 26.0531 1.60771 23.0228 0.907575Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoMobile);
export default __webpack_public_path__ + "static/media/header-logo-mobile.aea27f12f61dd84e9af5f12454588c07.svg";
export { ForwardRef as ReactComponent };